export default __webpack_public_path__ + "static/ampm-brand--mobile@1x-733f420c79c945d24d2f40f03b4d02f0.jpg";